<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)] auth-cover-wrapper">
    <template #left>
      <div class="auth-cover-content-inner" style="width: 70vw">
        <div class="auth-cover-content-wrapper">
          <div class="auth-img">
            <img :src="img_path" alt="" class="img-fluid" />
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div class="h-full flex items-center justify-center h-100">
        <RouterView />
      </div>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4 h-100">
        <main class="h-full flex flex-row items-center justify-start h-100">
          <div class="flex flex-col items-start w-100">
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script setup>
import { useBreakpoint } from 'vuestic-ui'
import { useRouter } from 'vue-router'
import { computed, onMounted } from 'vue'
import { toast_success } from '@/utils/obtoast'
const breakpoint = useBreakpoint()
const router = useRouter()
import { validate_email } from '@/apis/auth'
import i18n from '@/i18n'

const { t } = i18n.global

// 挂载函数
onMounted((res) => {
  const vcode = router.currentRoute.value?.query?.vcode
  const route_name = router.currentRoute.value?.name
  if (vcode && route_name) {
    // 验证邮箱
    validate_email({ vcode }).then((res) => {
      toast_success(t('toast.emailSuccess'))
    })
  }
})

// 图片
const img_path = computed(() => {
  let res = '/imgs/auth-cover-login-bg.svg'
  if (router.currentRoute.value.name == 'signup') {
    res = '/imgs/auth-cover-register-bg.svg'
  } else if (router.currentRoute.value.name == 'recover-password') {
    res = '/imgs/auth-cover-reset-bg.svg'
  } else if (router.currentRoute.value.name == 'recover-password-email') {
    res = '/imgs/auth-cover-verify-bg.svg'
  } else if (router.currentRoute.value.name == 'maintenance') {
    res = '/imgs/auth-cover-maintenance-bg.svg'
  }
  return res
})
</script>
